export interface SectionItem{
    title: string;
    items: SidebarItem[];
}

export interface SidebarItem {
  id: string;
  label: string;
    subLabel?: string;
  icon?: string;
  route?: string;
  code?: string;

  children?: SidebarItem[];

  expanded?: boolean;
}

export const SECTION_ITEMS: SectionItem[] = [
    {
    title: 'General',
    items:
        [
            {
                id: 'dashboard',
                label: 'Dashboard',
                icon: '/sidebar/dashboard.svg',
                children: [
                {
                    id: 'dashboard-gerencial',
                    label: 'Gerencial',
                    route: '/dashboard/gerencial',
                    code: 'DASHBOARD_GERENCIAL'
                },
                {
                    id: 'dashboard-reservas',
                    label: 'Reservas',
                    route: '/dashboard/reservas',
                    code: 'DASHBOARD_RESERVAS'
                },
                {
                    id: 'dashboard-fullday',
                    label: 'Full Day',
                    route: '/dashboard/fullday',
                    code: 'DASHBOARD_FULLDAY'
                },
                {
                    id: 'dashboard-canal-publicidad',
                    label: 'Canal y Publicidad',
                    route: '/dashboard/canal-publicidad',
                    code: 'DASHBOARD_CANAL_PUBLICIDAD'
                },
                {
                    id: 'dashboard-houskeeping',
                    label: 'Houskeeping',
                    route: '/dashboard/houskeeping',
                    code: 'DASHBOARD_HOUSKEEPING'
                },
                {
                    id: 'dashboard-encuestas',
                    label: 'Encuestas',
                    route: '/dashboard/encuestas',
                    code: 'DASHBOARD_ENCUESTAS'
                },
                {
                    id: 'dashboard-promotores',
                    label: 'Promotores',
                    route: '/dashboard/promoter',
                    code: 'DASHBOARD_PROMOTORES'
                }
                ],
                expanded: false
            },
            {
                id: 'gestor-de-usuarios',
                label: 'Gestor de usuarios',
                icon: '/sidebar/gestor-usuarios.svg',
                children: [
                {
                    id: 'roles-y-accesos',
                    label: 'Roles y accesos',
                    route: '/gestor-de-usuarios/roles-y-accesos',
                    code: 'GESTOR_ROLES_ACCESOS'
                },
                {
                    id: 'usuarios',
                    label: 'Usuarios',
                    route: '/gestor-de-usuarios/usuarios',
                    code: 'GESTOR_USUARIOS'
                }
                ],
                expanded: false
            }
        ]
    },
    {
    title: 'Hotel',
    items:
        [
            {
                id: 'apartamentos',
                label: 'Apartamentos',
                icon: '/sidebar/apartamentos.svg',
                children: [
                {
                    id: 'configuracion-alojamientos',
                    label: 'Configuracion de Alojamientos',
                    route: '/apartamentos/configuracion-de-alojamientos',
                    code: 'APARTAMENTOS_CONFIGURACION_ALOJAMIENTOS'
                },
                {
                    id: 'tipo-alojamiento',
                    label: 'Tipo de alojamiento',
                    route: '/apartamentos/tipo-de-alojamiento',
                    code: 'APARTAMENTOS_TIPO_ALOJAMIENTO'
                },
                {
                    id: 'tipo-camas',
                    label: 'Tipo de camas',
                    route: '/apartamentos/tipo-de-camas',
                    code: 'APARTAMENTOS_TIPO_CAMAS'
                },
                {
                    id: 'amenities',
                    label: 'Amenities',
                    route: '/apartamentos/amenities',
                    code: 'APARTAMENTOS_AMENITIES'
                }
                ],
                expanded: false
            },
            {
                id: 'reservas',
                label: 'Reservas',
                icon: '/sidebar/reservas.svg',
                children: [
                {
                    id: 'alojamiento',
                    label: 'Alojamiento',
                    route: '/reservas/alojamiento',
                    code: 'RESERVAS_ALOJAMIENTO'
                },
                {
                    id: 'uso-de-rewards',
                    label: 'Uso de Rewards',
                    route: '/reservas/uso-de-rewards',
                    code: 'CONFIGURACION_OCUPACION'
                },
                {
                    id: 'reservas-promociones',
                    label: 'Promociones',
                    route: '/reservas/promociones',
                    code: 'PROMOCIONES_LISTA'
                },
                ],
                expanded: false
            },
            {
                id: 'servicios',
                label: 'Servicios',
                icon: '/sidebar/servicios.svg',
                route: '/servicios',
                code: 'GESTOR_SERVICIOS'
            },
            {
                id: 'promociones',
                label: 'Promociones',
                icon: '/sidebar/promociones.svg',
                children: [
                {
                    id: 'promociones',
                    label: 'Promociones',
                    route: '/gestor-promociones/tipos',
                    code: 'PROMOCIONES_LISTA'
                },
                {
                    id: 'lista-promociones',
                    label: 'Lista de promociones',
                    route: '/gestor-promociones/lista',
                    code: 'PROMOCIONES_LISTA'
                },
                {
                    id: 'actividades-promociones',
                    label: 'Actividad de promociones',
                    route: '/gestor-promociones/actividades-de-promociones',
                    code: 'PROMOCIONES_ACTIVIDADES'
                },
                {
                    id: 'gestor-pagos-promociones',
                    label: 'Gestor de pagos',
                    route: '/gestor-promociones/gestor-de-pagos',
                    code: 'PROMOCIONES_GESTOR_PAGOS'
                }
                ],
                expanded: false
            },
            {
                id: 'paquetes-fulldays',
                label: 'Paquetes o fulldays',
                icon: '/sidebar/paquetes-fulldays.svg',
                children: [


                  {
                      id: 'control-accesos-fulldays',
                      label: 'Control de Accesos FullDays',
                      route: '/paquetes-fulldays/control-de-accesos-fulldays',
                      code: 'PAQUETES_FULLDAYS_CONTROL'
                  },
                  {
                      id: 'tarifas',
                      label: 'Tarifas',
                      route: '/paquetes-fulldays/tarifas',
                      code: 'PAQUETES_FULLDAYS_TARIFAS'
                  },
                  {
                      id: 'reporte-registro',
                      label: 'Reporte de registro',
                      route: '/paquetes-fulldays/reporte-de-registros',
                      code: 'PAQUETES_FULLDAYS_REPORTE'
                  }
                ],
                expanded: false
            },
            {
                id: 'bandeja-promotor',
                label: 'Bandeja de promotor',
                icon: '/sidebar/bandeja-promotor.svg',
                route: '/bandeja-de-promotor',
                code: 'BANDEJA_PROMOTOR'
            },
            {
                id: 'gestor-de-pagos-manuales',
                label: 'Gestor de pagos manuales',
                icon: '/sidebar/gestor-pagos.svg',
                route: '/gestor-de-pagos-manuales',
                code: 'GESTOR_PAGOS_MANUALES'
            },
            {
                id: 'gestor-de-pagos',
                label: 'Gestor de pagos',
                icon: '/sidebar/gestor-pagos.svg',
                children: [
                    {
                        id: 'validacion-de-pagos',
                        label: 'Validación de pagos',
                        route: '/gestor-de-pagos/validacion-de-pagos',
                        code: 'GESTOR_PAGOS_VALIDACION'
                    },
                    {
                        id: 'ingresos-egresos',
                        label: 'Ingresos y Egresos',
                        route: '/gestor-de-pagos/ingresos-y-egresos',
                        code: 'GESTOR_PAGOS_INGRESOS_EGRESOS'
                    },
                    {
                        id: 'conciliacion-efectivo',
                        label: 'Conciliación de efectivo',
                        route: '/gestor-de-pagos/conciliacion-de-efectivo',
                        code: 'GESTOR_PAGOS_CONCILIACION_EFECTIVO'
                    },
                    {
                        id: 'conciliacion-niubiz',
                        label: 'Conciliación de Niubiz',
                        route: '/gestor-de-pagos/conciliacion-de-niubiz',
                        code: 'GESTOR_PAGOS_CONCILIACION_NIUBIZ'
                    },
                    {
                        id: 'historial-ventas',
                        label: 'Historial de ventas',
                        route: '/gestor-de-pagos/historial-de-ventas',
                        code: 'GESTOR_PAGOS_HISTORIAL_VENTAS'
                    }
                ],
                expanded: false
            },
            {
                id: 'gestor-de-pagos-parciales',
                label: 'Gestor de Pago Parcial',
                icon: '/sidebar/money-time.svg',
                route: '/gestor-de-pagos-parciales',
                code: 'GESTOR_PAGOS_PARCIALES'
            },
            {
                id: 'disponibilidad',
                label: 'Disponibilidad',
                icon: '/sidebar/disponibilidad.svg',
                route: '/disponibilidad',
                code: 'DISPONIBILIDAD'
            },
        ]
    },
    {
    title: 'Costeo y Presupuesto de Eventos',
    items:
        [
            {
                id: 'productos-servicios-eventos',
                label: 'Productos/Servicios Eventos',
                icon: '/event-products/product.svg',
                route: '/productos-servicios-eventos/brindis-bocaditos',
                code: 'PRODUCTOS_SERVICIOS_EVENTOS'
            },
            {
                id: 'tipos-de-eventos',
                label: 'Tipos de Eventos',
                icon: '/event-types/event-types.svg',
                route: '/tipos-de-eventos',
                code: 'TIPOS_DE_EVENTOS'
            },
            {
                id: 'solicitudes-de-cotizacion',
                label: 'Solicitudes de cotización',
                icon: '/event-quotes/sidebar.svg',
                route: '/solicitudes-de-cotizacion',
                code: 'SOLICITUDES_DE_COTIZACION'
            },
            {
                id: 'calendario-de-eventos',
                label: 'Calendario de Eventos',
                icon: '/event-calendar/sidebar.svg',
                route: '/calendario-de-eventos',
                code: 'CALENDARIO_DE_EVENTOS'
            }
        ]
    },
    {
    title: 'Room status, canjes y rewards',
    items:
        [
            {
                id: 'gestor-transferencia',
                label: 'Gestor de transferencia',
                icon: '/sidebar/gestor-transferencia.svg',
                route: '/gestor-de-transferencia',
                code: 'GESTOR_TRANSFERENCIA'
            },
            {
                id: 'gestor-ocupacion',
                label: 'Gestor de ocupación',
                icon: '/sidebar/gestor-ocupacion.svg',
                children: [
                {
                    id: 'gestion-de-ocupacion',
                    label: 'Gestión de ocupación',
                    route: '/gestor-de-ocupacion',
                    code: 'GESTOR_OCUPACION'
                },
                {
                    id: 'configuracion-de-ocupacion',
                    label: 'Configuración de ocupación',
                    route: '/gestor-de-ocupacion/configuracion-de-ocupacion',
                    code: 'CONFIGURACION_OCUPACION'
                },
                {
                    id: 'gestor-de-ocupacion-actividades',
                    label: 'Actividades',
                    route: '/gestor-de-ocupacion/actividades',
                    code: 'GESTOR_OCUPACION_ACTIVIDADES'
                },
                {
                    id: 'gestor-de-ocupacion-room-list',
                    label: 'Room List',
                    route: '/gestor-de-ocupacion/roomlist',
                    code: 'GESTOR_OCUPACION_ROOMLIST'
                }
                ],
                expanded: false
            }
        ]
    },
    {
    title: 'Clientes, promotores y socios',
    items:
        [
            {
                id: 'gestor-clientes',
                label: 'Gestor de clientes',
                icon: '/sidebar/gestor-clientes.svg',
                route: '/gestor-clientes',
                code: 'GESTOR_CLIENTES'
            },
            {
                id: 'gestor-socios',
                label: 'Gestor de socios',
                icon: '/sidebar/gestor-socios.svg',
                route: '/gestor-socios',
                code: 'GESTOR_SOCIOS'
            },
            {
                id: 'gestor-promotores',
                label: 'Gestor de promotores',
                icon: '/sidebar/gestor-promotores.svg',
                children: [
                {
                    id: 'usuarios-promotores',
                    label: 'Usuarios Promotores',
                    route: '/gestor-promotores/usuarios-promotores',
                    code: 'USUARIOS_PROMOTORES'
                },
                {
                    id: 'solicitudes-promotores',
                    label: 'Solicitudes Promotores',
                    route: '/gestor-promotores/solicitudes-promotores',
                    code: 'SOLICITUDES_PROMOTORES'
                },
                ]
            },

        ]
    },
    {
    title: 'Inventario de productos',
    items:
        [
            {
                id: 'gestor-almacenes',
                label: 'Almacenes',
                icon: '/sidebar/gestor-almacenes.png',
                route: '/gestor-almacenes',
                code: 'GESTOR_ALMACENES'
            },
            {
                id: 'productos',
                label: 'Productos',
                icon: '/sidebar/bottle.svg',
                children: [
                {
                    id: 'listado-productos',
                    label: 'Listado de productos',
                    route: '/productos/listado-de-productos',
                    code: 'PRODUCTOS_LISTADO'
                },
                {
                    id: 'categorias-subcategorias',
                    label: 'Categorías y Subcategorías',
                    route: '/gestor-categorias',
                    code: 'CATEGORIAS_SUBCATEGORIAS'
                },
                {
                    id: 'lista-proveedores',
                    label: 'Lista de proveedores',
                    route: '/productos/lista-de-proveedores',
                    code: 'LISTA_PROVEEDORES'
                },
                {
                    id: 'productos-departamentos',
                    label: 'Productos por departamento',
                    route: '/gestor-combos/productos-departamentos',
                    code: 'PRODUCTOS_DEPARTAMENTOS'
                },
                {
                    id: 'movimientos-inventario',
                    label: 'Movimientos',
                    route: '/gestor-almacenes/stock-movement',
                    code: 'MOVIMIENTOS_INVENTARIO'
                },
                {
                    id: 'vencimientos',
                    label: 'Vencimientos',
                    route: '/vencimientos',
                    code: 'VENCIMIENTOS_PRODUCTOS'
                },
                ],
                expanded: false
            },
            {
                id: 'housekeeping',
                label: 'Housekeeping',
                icon: '/sidebar/healthicons_cleaning-outline.png',
                route: '/productos/housekeeping',
                code: 'PRODUCTOS_HOUSEKEEPING'
            },
            {
                id: 'gestor-reportes',
                label: 'Reporte',
                icon: '/sidebar/gestor-reportes.png',
                route: '/gestor-reportes',
                code: 'GESTOR_REPORTES'
            }
        ]
    },
    {
    title: 'Sitio Web y Contenido',
    items:
        [
            {
                id: 'gestor-contenido-web',
                label: 'Gestor de contenido web',
                icon: '/sidebar/gestor-contenido-web.svg',
                children: [
                {
                    id: 'home-contenido-web',
                    label: 'Home',
                    route: '/gestor-de-contenidos/home-contenido-web',
                    code: 'GESTOR_CONTENIDO_HOME'
                },
                {
                    id: 'servicios-contenido-web',
                    label: 'Servicios',
                    route: '/gestor-de-contenidos/servicios-contenido-web',
                    code: 'GESTOR_CONTENIDO_SERVICIOS'
                },
                {
                    id: 'nosotros-contacto-contenido-web',
                    label: 'Nosotros / Contacto',
                    subLabel: 'Gestor de datos',
                    route: '/gestor-de-contenidos/nosotros-contacto-contenido-web',
                    code: 'GESTOR_CONTENIDO_NOSOTROS_CONTACTO'
                },
                {
                    id: 'pop-up-contenido-web',
                    label: 'Pop Up',
                    route: '/gestor-de-contenidos/gestor-de-popups',
                    code: 'GESTOR_CONTENIDO_POPUP'
                },
                {
                    id: 'libro-reclamaciones-contenido-web',
                    label: 'Libro de reclamaciones',
                    route: '/gestor-de-contenidos/libro-de-reclamaciones',
                    code: 'GESTOR_CONTENIDO_LIBRO_RECLAMACIONES'
                },
                ],
                expanded: false
            }
        ]
    },
    {
    title: 'Contabilidad',
    items:
        [
            {
                id: 'validacion-comisiones',
                label: 'Validación de comisiones',
                icon: '/sidebar/validacion-comisiones.svg',
                children: [
                {
                    id: 'validacion-comisiones-automatica',
                    label: 'Validación Automatica',
                    route: '/validacion-comisiones',
                    code: 'VALIDACION_COMISIONES'
                },
                {
                    id: 'validacion-comisiones-historico',
                    label: 'Historico',
                    route: '/validacion-comisiones/historico',
                    code: 'VALIDACION_COMISIONES_HISTORICO'
                }
                ],
                expanded: false
            },
            {
                id: 'retiros',
                label: 'Retiros',
                icon: '/sidebar/withdrawal.svg',
                children: [
                {
                    id: 'bcp',
                    label: 'BCP',
                    route: '/retiros/bcp',
                    code: 'RETIRO_BCP'
                }
                ],
                expanded: false
            },
            {
                id: 'auditoria',
                label: 'Auditoria',
                icon: '/sidebar/validacion-comisiones.svg',
                route: '/auditoria',
                code: 'AUDITORIA'
            }
        ]
    },
    {
        title: 'Macros bancarios',
        items: [
            {
                id: 'macros-bancarios',
                label: 'Macros bancarios',
                icon: '/sidebar/validacion-comisiones.svg',
                children: [
                {
                    id: 'adjuntar-macros',
                    label: 'Adjuntar Macros',
                    route: '/gestor-de-pagos/validacion-de-pagos/macros-bancarios',
                    code: 'MACROS_BANCARIOS_ADJUNTAR'
                },
                {
                    id: 'historial-de-cargas',
                    label: 'Historial de cargas',
                    route: '/gestor-de-pagos/validacion-de-pagos/macros-bancarios/historial',
                    code: 'MACROS_BANCARIOS_HISTORIAL'
                }
                ],
                expanded: false
            }
        ]
    },
    {
    title: 'Soporte',
    items:
        [
            {
                id: 'sistema-contingencia',
                label: 'Sistema de contingencia',
                icon: '/sidebar/sistema-contingencia.svg',
                children: [
                {
                    id: 'contingencias',
                    label: 'Contingencias',
                    route: '/contingencias',
                    code: 'SISTEMA_CONTINGENCIA_CONTINGENCIAS'
                }
                ],
                expanded: false
            }
        ]
    },

];
